import React from 'react';
import { Link } from 'react-router-dom';

export default function SectionHeader({ title, subtitle, breadcrumb }) {
  return (
    <div className="bg-gradient-to-r from-black to-red-700 text-white py-10 md:py-16">
      <div className="container mx-auto px-4 text-center">
        {Array.isArray(breadcrumb) && breadcrumb.length > 0 && (
          <nav className="mb-3 text-sm">
            {breadcrumb.map((b, i) => (
              <span key={i} className="text-white/80">
                {b.to ? <Link to={b.to} className="hover:text-white">{b.label}</Link> : b.label}
                {i < breadcrumb.length - 1 && <span className="mx-2">/</span>}
              </span>
            ))}
          </nav>
        )}
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight">{title}</h1>
        {subtitle && (
          <p className="mt-3 max-w-2xl mx-auto text-base md:text-lg text-white/90">{subtitle}</p>
        )}
      </div>
    </div>
  );
}